export class NICEUnavailableCode {
    outStateId: number;
    outStateName: string;
    isActive: boolean;
    isAcw: boolean;
    agentTimeoutMins: number;

    constructor(niceUnavailableCode?) {
        if (niceUnavailableCode) {
            this.outStateId = niceUnavailableCode.outStateId || 0;
            this.outStateName = niceUnavailableCode.outStateName || '';
            this.isActive = niceUnavailableCode.isActive || false;
            this.isAcw = niceUnavailableCode.isAcw || false;
            this.agentTimeoutMins = +niceUnavailableCode.agentTimeoutMins || 0;
        }else{
            this.outStateId = 0;
            this.outStateName = '(System Default)';
            this.isActive = true;
            this.isAcw = false;
            this.agentTimeoutMins = 120;
        }
    }
}
